import React, {Component} from "react"
import "./ProfilesLinkingDropdown.scss";

const placeholder = "-Select-";

/**
* requires the following props: profiles, selectProfile, prefill
*/
class  ProfilesLinkingDropdown extends Component{
    render(){
        const { profiles } = this.props

        return (
            <div className="grid-row profiles-linking-dd-container">
                <div  className="grid-col-12 profiles-linking-dd">
                    <span className="profiles-linking-text">Select a profile to populate this section </span>
                    <select className="usa-select"
                        onKeyPress={(e) => {
                            if(e.which === 13 || e.keyCode === 13 || e.which === 0 || e.keyCode === 0) {// for crossbrowser
                                e.preventDefault(); // this code prevents other buttons triggers use this
                            }
                        }}
                        onChange={(e) => { this.props.selectProfile( e.target.value ) }}
                        value={ this.props.index }
                    >
                      <option key={-1} value={placeholder}>{placeholder}</option>
                      {profiles && profiles.map((profile, index) => {
                          return (
                              <option key={index} value={index}>
                                  {profile.name}
                              </option>
                          );
                      })}
                    </select>
                    <button className="usa-button profiles-linking-btn" disabled={this.props.selected === placeholder ? true : false}
                        onClick={() => { this.props.prefill() }
                    }
                    >Populate</button>
                </div>
            </div>
        )
    }

}

export default ProfilesLinkingDropdown;
